import { createContext } from "react";
export const WhatsUpWhatsNextContext = createContext();
